const Menu06Icon = /*#__PURE__*/ [
  ["path", { d: "M4 5L20 5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 12L8 12M20 12L11 12M8 12L9.5 14L11 12M8 12L11 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4 19L20 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export { Menu06Icon as default };
//# sourceMappingURL=Menu06Icon.js.map
